import * as React from "react";
import { useQuery } from "@grandvisionhq/graphql";
import { useFeatureToggles } from "@grandvisionhq/state";
import { mapCartDiscountToClient } from "./map-to-client-cart-discount.js";
import { GET_CART_DISCOUNTS_BY_PROMOTION_IDENTIFIER } from "../../../../operations/queries/operations/queries/get-cart-discounts-by-promotion-identifier.js";
const useCartDiscountInternal = (promotionIdentifier) => {
  const { isCartDiscountsEnabled } = useFeatureToggles();
  const { data, loading, error } = useQuery(GET_CART_DISCOUNTS_BY_PROMOTION_IDENTIFIER, {
    skip: !isCartDiscountsEnabled || !promotionIdentifier,
    variables: { promotionIdentifier: promotionIdentifier || "" }
  });
  if (error) {
    console.error(error);
  }
  return {
    loading,
    data
  };
};
const useCartDiscountsQuery = (promotionIdentifier, selectedQuantity) => {
  const { loading, data } = useCartDiscountInternal(promotionIdentifier);
  const cartDiscounts = React.useMemo(() => {
    return mapCartDiscountToClient(data?.getCartDiscountsByPromotionIdentifier);
  }, [data]);
  const activeDiscount = React.useMemo(() => {
    if (!selectedQuantity) {
      return void 0;
    }
    const sortedDescendingDiscounts = [...cartDiscounts].sort(
      (a, b) => b.minimumQuantity - a.minimumQuantity
    );
    return sortedDescendingDiscounts.find(
      (discount) => selectedQuantity >= discount.minimumQuantity
    );
  }, [cartDiscounts, selectedQuantity]);
  return {
    loading,
    cartDiscounts,
    activeDiscount
  };
};
export {
  useCartDiscountsQuery
};
//# sourceMappingURL=use-cart-discounts-query.js.map
